import { render, staticRenderFns } from "./FrsErrorReportForm.vue?vue&type=template&id=232e08ec&scoped=true&lang=html&"
import script from "./FrsErrorReportForm.vue?vue&type=script&lang=js&"
export * from "./FrsErrorReportForm.vue?vue&type=script&lang=js&"
import style0 from "./FrsErrorReportForm.vue?vue&type=style&index=0&id=232e08ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e08ec",
  null
  
)

export default component.exports